import React, { useEffect, useState } from 'react'
import Style from './ItemPicker.module.scss'
import CloseIcon from '@mui/icons-material/Close'

const ItemPicker = ({
  visible,
  setVisibility,
  label,
  data,
  onSelectChange,
  selectAll,
  unselectAll,
  rules,
  confirmChange
}) => {
  const { displayKey, primaryKey } = rules

  const [inputText, setInputText] = useState('')

  useEffect(() => {
    window.addEventListener('click', close)
    return () => window.removeEventListener('click', close)
  }, [])

  const close = () => {
    setVisibility(false)
  }

  const filterData = (data) => {
    if (!data) return []
    return inputText ? data.filter((_) => _[displayKey]?.includes(inputText)) : [...data]
  }

  return visible ? (
    <div className={`${Style['item-picker']}`} onClick={(e) => e.stopPropagation()}>
      <CloseIcon className={`${Style['close-icon']}`} onClick={() => close()} />
      <div className={`${Style['item-picker-header']}`}>
        <p>{label}</p>
        <div className={`${Style['item-picker-header-buttons']}`}>
          <button className={`${Style['blue']}`} onClick={selectAll}>
            全選択
          </button>
          <button className={`${Style['gray']}`} onClick={unselectAll}>
            全解除
          </button>
        </div>
      </div>
      {data.length ? (
        <div className={`${Style['item-picker-main']}`}>
          <div className={`${Style['item-input']}`}>
            <input type="text" placeholder={`${label}で検索`} value={inputText} onChange={(e) => setInputText(e.target.value)} />
            {inputText && <CloseIcon className={`${Style['delete-text']}`} onClick={() => setInputText('')} />}
          </div>
          <div className={`${Style['item-container']}`}>
            {filterData(data).map((_) => {
              return (
                <label className={`${Style['item']}`} key={`${_.index}-${_[displayKey]}`}>
                  <input
                    type="checkbox"
                    checked={_.checked}
                    onChange={(e) => onSelectChange(e.target.checked, _.index)}
                  />
                  {_[displayKey] ?? ''}
                </label>
              )
            })}
          </div>
        </div>
      ) : (
        <div className={`${Style['no-options-message']}`}>選択肢がありません</div>
      )}
      <div className={`${Style['item-picker-footer']}`}>
        <button className={`${!filterData(data).length && Style['disabled']}`} onClick={confirmChange}>
          適応
        </button>
      </div>
    </div>
  ) : null
}

export default ItemPicker
